import setAgentPreferences from 'actions/agent_preferences/set_agent_preferences';
import { SidePanelType } from 'models/side_panel';

export default class OpenAnswerPanel {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, conversationId, compositionId }) {
    this.context.stores.languages.setLoading();
    this.context.gateways.language.fetch();

    const sidePanel = this.context.stores.sidePanel.get();
    if (!sidePanel.isShowing(SidePanelType.ANSWER)) {
      sidePanel.show(SidePanelType.ANSWER);
      this.context.stores.sidePanel.set(sidePanel);

      const preferences = this.context.stores.agentPreferences.get();
      preferences.setSidePanel(sidePanel);
      preferences.setAnswerPanelLastOpenedAt(sidePanel.panelLastShownAt);
      setAgentPreferences(this.context, preferences);
    }

    this.context.analytics.track('Answer Panel Opened', { customerId, conversationId, compositionId });
  }
}
